import { combineReducers } from 'redux';

import { reducer as searchReducer } from '../../common/store/search';
import { reducer as mapboxGlReducer } from '../../map/store';
import { reducer as itemDetailsReducer } from '../../pages/item-details/store';
import { reducer as itemEditReducer } from '../../common/store/item-edit';
import { reducer as wizardReducer } from '../../common/store/wizard';
import { reducer as uiReducer } from '../../common/store/ui';
import { reducer as userNotificationSettingsReducer } from '../../common/store/user-notificaition-settings';

import { State } from './state.types.ts';

export default combineReducers<State>({
  search: searchReducer,
  mapboxGl: mapboxGlReducer,
  itemDetails: itemDetailsReducer,
  itemEdit: itemEditReducer,
  wizard: wizardReducer,
  ui: uiReducer,
  userNotificationsSettings: userNotificationSettingsReducer,
});
